import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { EmotionalSection } from './components/EmotionalSection';
import { PainSection } from './components/PainSection';
import { DreamSection } from './components/DreamSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { OfferStack } from './components/OfferStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FinalCTA } from './components/FinalCTA';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-forest selection:bg-terracotta/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <EmotionalSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <DreamSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <ProductSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <OfferStack data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <UrgencySection data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <FAQSection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}